<template>
    <span @click.stop="onClick">
        <template v-if="isShowAll">{{phone}}</template>
        <template v-else>{{phone|phone}}</template>
    </span>
</template>

<script>
export default {
    props: {
        phone: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isShowAll: false,
        }
    },
    methods: {
        onClick() {
            this.isShowAll = !this.isShowAll;
        },
    },

}
</script>

<style>
</style>